(ns practitest.frontend.forms3.project-field-form
  (:require [practitest.frontend.common.re-frame :refer [partial-dispatch partial-subscribe partial-dispatch-sync]]
            [practitest.frontend.forms3.entity-form.forms :as forms3]
            [practitest.frontend.forms3.custom-field-form-common :as cf-form-common]
            [practitest.frontend.components.forms :as forms-components]
            [goog.object :as gobj]
            [practitest.frontend.project-fields-settings.events :as pf-events]
            [practitest.frontend.project-fields-settings.subs :as pf-subs]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.subs :as subs]
            [reagent.core :as r]
            [re-frame.core :as re-frame]))

(def ^:private custom-field-form-id :project-fields-form)

(def ^:private keys-cfg
  {:name            :cf-name
   :format          :cf-format
   :parent-list     :cf-parent-list
   :possible-values :cf-possible-values
   :source-list     :cf-source-list
   :entity-table    :cf-entity
   :select-projects nil})

(defn- project-field-fields-props [{:keys [edit? field-format is-global-field?]}]
  (cf-form-common/fields-props
   {:edit? edit?
    :field-format field-format
    :name-field-type (when is-global-field? :glb-prefixed-text)
    :name-editable? (not is-global-field?)
    :list-field-names @(re-frame/subscribe [:project-fields-settings/list-field-names])
    :on-clear-dependent-fields #(re-frame/dispatch [::pf-events/clear-dependent-fields [:cf-possible-values :cf-source-list]])
    :keys-cfg keys-cfg}))

(re-frame/reg-sub
 ::project-field-props
 (fn [_db [_ edit? field-format is-global-field? field-name]]
   (first (filter #(= (:field-name %) field-name) (project-field-fields-props {:edit? edit? :field-format field-format :is-global-field? is-global-field?})))))

(defn- project-field-form-props [{:keys [edit? field-format is-global-field?]}]
  {:get-field-props (partial-subscribe [::project-field-props edit? field-format is-global-field?])
   :get-form-state  (partial-subscribe [::forms3/form-state custom-field-form-id])
   :set-form-state  (partial-dispatch [::forms3/set-form-state custom-field-form-id])

   :get-field-state (partial-subscribe [::forms3/field-state custom-field-form-id])
   :set-field-state (partial-dispatch-sync [::forms3/set-field-state custom-field-form-id])})

(defn force-form-validation! [{:keys [edit? field-format is-global-field?]}]
   (let [{:keys [set-form-state
                 get-form-state
                 get-field-props]} (project-field-form-props {:edit? edit? :field-format field-format :is-global-field? is-global-field?})
         new-form-state (let [form-state @(get-form-state)]
                          (reduce
                           (fn [form-state field]
                             (update-in form-state [:fields field]
                                        (fn [field-state]
                                          (let [props @(get-field-props field)]
                                            (assoc field-state :errors (forms-components/validate-all (:validators props) (:value field-state)))))))
                           form-state
                           (map :field-name (project-field-fields-props {:edit? edit? :field-format field-format :is-global-field? is-global-field?}))))]
     (set-form-state new-form-state)
     (into {}
           (comp
            (map (fn [[field field-state]]
                   (if (seq (:errors field-state))
                     [field (:errors field-state)]
                     nil)))
            (remove nil?))
           (:fields new-form-state))))

(defn- on-delete-item [edit? form-data]
  (fn [item]
    (mixpanel/track
     "Delete_Project_Field_Value"
     {"Type" (get-in form-data [:cf-format :value])})
    (if edit?
      (re-frame/dispatch [::pf-events/check-item-value-usage item])
      (re-frame/dispatch [::pf-events/delete-item-from-create-form item]))))

(defn- on-add-item [form-data]
  (fn [_]
    (mixpanel/track
     "Adding_Project_Field_Value"
     {"Type" (get-in form-data [:cf-format :value])})))

(defn- on-edit-item [_edit? form-data]
  (fn [item]
    (mixpanel/track
     "Rename_Project_Field_Value"
     {"Type" (get-in form-data [:cf-format :value])})
    (re-frame/dispatch [::pf-events/open-rename-value-modal item nil])))

(defn- linked-on-delete-item [edit? form-data]
  (fn [parent-item]
    (fn [item]
      (mixpanel/track
       "Delete_Project_Field_Value"
       {"Type" (get-in form-data [:cf-format :value])})
      (if edit?
        (re-frame/dispatch [::pf-events/check-item-value-usage item (keyword parent-item)])
        (re-frame/dispatch [::pf-events/delete-item-from-create-form item (keyword parent-item)])))))

(defn- linked-on-edit-item [_edit? form-data]
  (fn [parent-item]
    (fn [item]
      (mixpanel/track
       "Rename_Project_Field_Value"
       {"Type" (get-in form-data [:cf-format :value])})
      (re-frame/dispatch [::pf-events/open-rename-value-modal item (keyword parent-item)]))))

(defn- render-project-field-form [{:keys [edit?]}]
  (let [form-data @(re-frame/subscribe [::pf-subs/custom-fields-form-data])
        field-format (get-in form-data [:cf-format :value])
        loading? @(re-frame/subscribe [:project-fields-settings/form-loading?])
        parent-list (get-in form-data [:cf-parent-list :value])
        parent-list-items @(re-frame/subscribe [:project-fields-settings/list-items parent-list])
        possible-values (get-in form-data [:cf-possible-values :value])
        users @(re-frame/subscribe [::subs/users])
        action-in-progress? @(re-frame/subscribe [::pf-subs/possible-value-action-in-progress?])
        seeded-cf      @(re-frame/subscribe [:project-fields-settings/seeded-custom-field])
        is-global-field? (:is_global_field seeded-cf)
        disabled-entities (:disabled-entity-keys seeded-cf)
        source-list-options (when-not is-global-field?
                              @(re-frame/subscribe [::pf-subs/source-list-options]))
        source-list (get-in form-data [:cf-source-list :value])
        on-source-list-change (fn [selected-obj]
                                (if (nil? selected-obj)
                                  (re-frame/dispatch [::pf-events/clear-source-list])
                                  (if (seq (get-in form-data [:cf-possible-values :value]))
                                    (re-frame/dispatch [::pf-events/show-source-list-confirm selected-obj])
                                    (re-frame/dispatch [::pf-events/apply-source-list selected-obj]))))
        form-props (project-field-form-props {:edit? edit? :field-format field-format :is-global-field? is-global-field?})]
    [:<>
     (cf-form-common/render-form-body
      {:edit? edit?
       :field-format field-format
       :loading? loading?
       :fields-props-list (project-field-fields-props {:edit? edit? :field-format field-format :is-global-field? is-global-field?})
       :form-props form-props
       :keys-cfg keys-cfg
       ;; For global linkedlist fields the parent is a global field not in the
       ;; project fields index, so list-items returns nil. Fall back to the keys
       ;; of the linkedlist's own possible_values (which maps parent => children).
       :parent-list-items (or (when parent-list (seq parent-list-items))
                              (when (and is-global-field? (= field-format "linkedlist"))
                                (keys possible-values)))
       :on-delete-item (if (= field-format "linkedlist")
                         (linked-on-delete-item edit? form-data)
                         (on-delete-item edit? form-data))
       :on-add-item (on-add-item form-data)
       :on-edit-item (if (= field-format "linkedlist")
                       (linked-on-edit-item edit? form-data)
                       (on-edit-item edit? form-data))
       :is-global-field? is-global-field?
       :show-select-projects? false
       :source-list-options source-list-options
       :source-list source-list
       :on-source-list-change on-source-list-change
       :entity-linker-opts {:available? true
                            :field-format field-format
                            :show-default-value? true
                            :possible-values (when (vector? possible-values) possible-values)
                            :users users
                            :disabled-entities disabled-entities
                            ;; Global Fields enforce linkage, but defaults are set per project
                            :default-editable-on-disabled-entities? true}
       :action-in-progress? action-in-progress?})]))

(defn- project-field-form-edit []
  (r/with-let [_ (let [custom-field @(re-frame/subscribe [:project-fields-settings/seeded-custom-field])]
                   (if custom-field
                     (re-frame/dispatch [::pf-events/init-form-values custom-field])
                     (.replace (gobj/get js/document "location") "/permission_error")))]
    [render-project-field-form {:edit? true}]))

(defn project-field-form [{:keys [edit?]}]
  (let [init-done? @(re-frame/subscribe [:project-fields-settings/init-complete?])]
    (when init-done?
      (if edit?
        [project-field-form-edit]
        [render-project-field-form {:edit? edit?}]))))
